namespace Matrix.Data {

    export interface SecurityMergePickerOptions  {
        repairSecurityId?: number;
        repairSourceCode?: string;
    }

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.flexify()
    export class SecurityMergePickerDialog extends Serenity.TemplatedDialog<SecurityMergePickerOptions> {

        private pickerGrid: SecurityMergePickerGrid;

        constructor(opt: SecurityMergePickerOptions) {
            super(opt);

            this.pickerGrid = new SecurityMergePickerGrid(this.byId("PickerGrid"), opt);
            this.pickerGrid.element.flexHeightOnly();
            this.dialogTitle = "Repair Match";
        }

        protected getTemplate() {
            return `<div id="~_PickerGrid"></div>`;
        }

        protected getDialogOptions() {
            var opt = super.getDialogOptions();
            opt.buttons = [
                {
                    text: Q.text("Dialogs.OkButton"),
                    click: () => {
                        var selected = this.pickerGrid.selectedItems;
                        if (!selected.length) {
                            Q.notifyWarning("Please select a item!");
                            return;
                        }

                        if (selected.length > 1) {
                            Q.notifyWarning("Please select a single item!");
                            return;
                        }

                        if (!this.onSuccess || this.onSuccess(selected))
                            this.dialogClose();
                    }
                },
                {
                    text: Q.text("Dialogs.CancelButton"),
                    click: () => {
                        this.dialogClose();
                    }
                }
            ];
            return opt;
        }

        get selectedItems() {
            return this.pickerGrid.selectedItems;
        }

        set criteria(value: any[]) {
            this.pickerGrid.criteria = value;
        }

        public onSuccess: (selected: SecurityMergeRow[]) => boolean;
    }
}